<template>
  <div class="h-full w-full overlay-modal">
    <div class="d-flex justify-space-between title w-full pa-3">
      <!-- <label v-if="viewerobj.file" class="text-sm font-medium">{{ viewerobj.file.name }}</label> -->
      <div class="mr-4">
        <v-icon class="white--text" @click="closeOverlay">{{ mdiClose }}</v-icon>
      </div>
    </div>

    <div class="d-flex justify-center align-center h-full w-full">
      <div class="d-flex relative">
        <v-icon color="white" class="mr-4 icon-left" @click="closeOverlay">
          {{ mdiArrowLeftCircleOutline }}
        </v-icon>
        <div>
          <img v-for="image in getImages" :key="image.src" :src="image.src" class="preview-img" />
        </div>

        <v-icon color="white" class="mr-4 icon-right" @click="$emit('next')">
          {{ mdiArrowRightCircleOutline }}
        </v-icon>
      </div>
    </div>
  </div>
</template>

<script>
import store from '@/store'
import { computed } from '@vue/composition-api'

import {
  mdiDownloadOutline,
  mdiArrowLeftCircleOutline,
  mdiArrowRightCircleOutline,
  mdiClose,
} from '@mdi/js'

export default {
  props: {
    src: {
      type: String,
      default: null,
    },
  },
  setup(props) {
    const getImages = computed(() => store.getters['imageViewer/getImages'])

    const closeOverlay = () => {
      store.commit('imageViewer/resetViewer')
    }

    return {
      closeOverlay,
      getImages,
      // icons
      mdiDownloadOutline,
      mdiArrowLeftCircleOutline,
      mdiArrowRightCircleOutline,
      mdiClose,
    }
  },
}
</script>

<style scoped>
.overlay-modal {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
}

.title {
  /* z-index: 100; */
  color: white;
}

.overlay-modal {
  background: rgb(0 0 0 / 85%);
}

.mh-100 {
  max-height: 100%;
}

.relative {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.icon-left,
.icon-right {
  position: fixed;
  top: 50%;
}

.icon-left {
  left: 3%;
}

.icon-right {
  right: 3%;
}

.preview-img {
  background-size: cover;
  height: 80%;
  width: 80%;
  border-radius: 8px;
}
</style>
